import type { EntityViewType } from "@config";
import "../styles/index.scss";

export const SimpleView = ({
  children,
}: {
  entity: EntityViewType;
  children: React.ReactNode;
}) => <div className="tw-w-full tw-space-y-4">{children}</div>;
